import { observer } from "mobx-react";
import React, { useMemo } from "react";

import { Link, Spinner, Toast, ToastBody, ToastFooter, ToastTitle } from "@fluentui/react-components";

import { M365PulseToastProps } from "./M365PulseToast.types";

const M365PulseToastBase = (props: M365PulseToastProps) => {
    const { toastMessage } = props;

    const actionName = useMemo(() => toastMessage.actionProps?.actionName || "", [toastMessage.actionProps?.actionName]);

    return (
        <Toast>
            {toastMessage.toastType === "progress" ? (
                <ToastTitle media={<Spinner size="tiny" aria-busy="true" aria-label="Loading Content" />}>{toastMessage.title}</ToastTitle>
            ) : (
                <ToastTitle>{toastMessage.title}</ToastTitle>
            )}

            {toastMessage.message && <ToastBody>{toastMessage.message}</ToastBody>}

            {actionName && (
                <ToastFooter>
                    <Link onClick={toastMessage.actionProps?.actionCallback}>{actionName}</Link>
                </ToastFooter>
            )}
        </Toast>
    );
};

export const M365PulseToast = observer(M365PulseToastBase);
